import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: null,
    authToken: localStorage.getItem("authToken") || null,
    moodMarkers: [
      {
        name: "didWorkout",
        icon: "fa-dumbbell",
        color: "green darken-4",
        tooltipText: "Worked Out",
      },
      {
        name: "didFollowKetoDiet",
        icon: "fa-utensils",
        color: "green",
        tooltipText: "Keto",
      },
      {
        name: "didGoForAWalk",
        icon: "fa-walking",
        color: "teal",
        tooltipText: "Went Outside",
      },

      {
        name: "didGoOut",
        icon: "fa-subway",
        color: "pink accent-2",
        tooltipText: "Went Out",
      },
      {
        name: "didTalkToSomeone",
        icon: "fa-comments",
        color: "pink accent-3",
        tooltipText: "Talked to someone",
      },
      {
        name: "didMeetWithSomeone",
        icon: "fa-handshake",
        color: "purple accent-3",
        tooltipText: "Met with someone",
      },
      {
        name: "hadFunWithFriends",
        icon: "fa-user-friends",
        color: "orange",
        tooltipText: "Had fun with friends",
      },
      {
        name: "hadFunAlone",
        icon: "fa-smile",
        color: "yellow darken-2",
        tooltipText: "Had fun by myself",
      },
      {
        name: "hadIntimateExperience",
        icon: "fa-heart",
        color: "red darken-2",
        tooltipText: "Had intimate experience with someone",
      },
      {
        name: "didMasturbate",
        icon: "fa-hand-paper",
        color: "cyan",
        tooltipText: "Masturbated",
      },
      {
        name: "didReadABook",
        icon: "fa-book",
        color: "blue lighten-2",
        tooltipText: "Read a book",
      },
    ],
    moodConditions: [
      {
        name: "skinIssues",
        emptyIcon: "fas fa-meh",
        fullIcon: "fas fa-meh",
        color: "pink lighten-2",
        helpText: "Skin",
      },
      {
        name: "healthIssues",
        emptyIcon: "far fa-plus-square",
        fullIcon: "fas fa-plus-square",
        color: "green darken-2",
        helpText: "Health",
      },
      {
        name: "sleepQuality",
        emptyIcon: "fa-bed",
        fullIcon: "fa-bed",
        color: "blue lighten-2",
        helpText: "Sleep Quality",
      },
      {
        name: "dietSatisfaction",
        emptyIcon: "fa-apple-alt",
        fullIcon: "fa-apple-alt",
        color: "green lighten-2",
        helpText: "Diet",
      },
      {
        name: "trainingSatisfaction",
        emptyIcon: "fa-heartbeat",
        fullIcon: "fa-heartbeat",
        color: "red",
        helpText: "Training",
      },
      {
        name: "productivitySatisfaction",
        emptyIcon: "fas fa-cog",
        fullIcon: "fas fa-cog",
        color: "blue",
        helpText: "Productivity",
      },
    ],
    moodRatings: [
      {
        name: "optimism",
        emptyIcon: "far fa-smile-beam",
        fullIcon: "far fa-smile-beam",
        color: "light-green",
        helpText: "Optimism",
      },
      {
        name: "energy",
        emptyIcon: "far fa-grin-tongue-wink",
        fullIcon: "far fa-grin-tongue-wink",
        color: "deep-orange lighten-2",
        helpText: "Energy",
      },
      {
        name: "frustration",
        emptyIcon: "far fa-angry",
        fullIcon: "far fa-angry",
        color: "red darken-2",
        helpText: "Frustration",
      },
      {
        name: "anxiety",
        emptyIcon: "far fa-grin-beam-sweat",
        fullIcon: "far fa-grin-beam-sweat",
        color: "cyan",
        helpText: "Anxiety",
      },
      {
        name: "confidence",
        emptyIcon: "far fa-grin-stars",
        fullIcon: "far fa-grin-stars",
        color: "pink accent-2",
        helpText: "Confidence",
      },
      {
        name: "loneliness",
        emptyIcon: "far fa-frown",
        fullIcon: "far fa-frown",
        color: "teal",
        helpText: "Loneliness",
      },
    ],
    moodDiaryRecords: [],
    pomodoroSessions: [],
    workoutPlans: [],
    completedExercises: [],
    exercises: [],
    weightRecords: [],
  },
  getters: {
    axiosConfig: (state) => {
      const authConfig = {
        headers: {
          Authorization: state.authToken,
        },
      };
      return state.authToken ? authConfig : {};
    },
    moodMetrics: (state) => {
      return state.moodConditions.concat(state.moodRatings);
    },
  },
  mutations: {
    // general
    toggleDrawer(state, value) {
      state.drawer = value;
    },
    updateAuthToken(state, value) {
      state.authToken = value;
    },

    // Pomodoro
    updatePomodoroSessions(state, pomodoroSessions) {
      state.pomodoroSessions = pomodoroSessions;
    },
    createPomodoroSession(state, record) {
      state.pomodoroSessions.push(record);
      state.pomodoroSessions.sort((a, b) => b.date.localeCompare(a.date));
    },
    updatePomodoroSession(state, record) {
      const recordIndex = state.pomodoroSessions.findIndex(
        (_record) => _record.id === record.id
      );
      Vue.set(state.pomodoroSessions, recordIndex, record);
    },
    deletePomodoroSession(state, record) {
      const recordIndex = state.pomodoroSessions.findIndex(
        (_record) => _record.id === record.id
      );
      state.pomodoroSessions.splice(recordIndex, 1);
    },

    // Mood diary
    updateMoodDiaryRecords(state, records) {
      state.moodDiaryRecords = records;
    },
    createMoodDiaryRecord(state, record) {
      state.moodDiaryRecords.push(record);
      state.moodDiaryRecords.sort((a, b) => b.date.localeCompare(a.date));
    },
    updateMoodDiaryRecord(state, record) {
      const recordIndex = state.moodDiaryRecords.findIndex(
        (_record) => _record.id === record.id
      );
      Vue.set(state.moodDiaryRecords, recordIndex, record);
    },
    deleteMoodDiaryRecord(state, record) {
      const recordIndex = state.moodDiaryRecords.findIndex(
        (_record) => _record.id === record.id
      );
      state.moodDiaryRecords.splice(recordIndex, 1);
    },

    // Training
    updateWorkoutPlans(state, workoutPlans) {
      state.workoutPlans = workoutPlans;
    },
    updateCompletedExercises(state, completedExercises) {
      state.completedExercises = completedExercises;
    },
    updateExercises(state, exercises) {
      state.exercises = exercises;
    },
    updateWeightRecords(state, weightRecords) {
      state.weightRecords = weightRecords;
    },
    createWeightRecord(state, record) {
      state.weightRecords.push(record);
      state.weightRecords.sort((a, b) => b.date.localeCompare(a.date));
    },
    updateWeightRecord(state, record) {
      const recordIndex = state.weightRecords.findIndex(
        (_record) => _record.id === record.id
      );
      Vue.set(state.weightRecords, recordIndex, record);
    },
    deleteWeightRecord(state, record) {
      const recordIndex = state.weightRecords.findIndex(
        (_record) => _record.id === record.id
      );
      state.weightRecords.splice(recordIndex, 1);
    },
  },
  actions: {
    setAuthToken(context, newToken) {
      localStorage.setItem("authToken", newToken);
      context.commit("updateAuthToken", newToken);
    },
    removeAuthToken(context) {
      localStorage.removeItem("authToken");
      context.commit("updateAuthToken", null);
    },
  },
  modules: {},
});
